import { post } from '@/lib/api';

/* ================================================================== */
/*  File search service — workspace-wide text search                  */
/* ================================================================== */

export interface SearchMatch {
  path: string;
  line: number;
  column: number;
  text: string;       // the matching line content
  matchStart: number; // char offset of match within `text`
  matchEnd: number;
}

export interface SearchResult {
  matches: SearchMatch[];
  totalMatches: number;
  filesSearched: number;
  truncated: boolean;
}

/**
 * Server-side search: POST /ide/workspaces/:id/search
 * Falls back to client-side search through the file tree if the endpoint
 * doesn't exist yet.
 */
export async function searchFiles(
  workspaceId: string,
  query: string,
  options?: { caseSensitive?: boolean; regex?: boolean; include?: string },
): Promise<SearchResult> {
  try {
    return await post<SearchResult>(
      `/ide/workspaces/${workspaceId}/search`,
      { query, ...options },
    );
  } catch {
    // Endpoint not yet implemented — return empty
    return { matches: [], totalMatches: 0, filesSearched: 0, truncated: false };
  }
}
